var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-button",class:{'menu-open': _vm.open },on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"menu-button-icon"},[_c('div',{staticClass:"h-bar"}),_c('div',{staticClass:"h-bar"}),_c('div',{staticClass:"h-bar"})])
}]

export { render, staticRenderFns }